<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Review Files
        <button type="button" class="close" @click.prevent="closeModal()"><span aria-hidden="true">&times;</span>
        </button>
      </h5>
    </div>
    <div class="container-fluid">
      <div v-if="generalErrorMessage" class="row">
        <div class="col">
          <div class="alert alert-danger" role="alert">
            {{ generalErrorMessage }}
          </div>
        </div>
      </div>
      <div class="file-container">
        <div class="file-list">
          <div class="my-4" v-for="(payeeDocument, index) in payeeDocuments" :key="'payeeDocument-' + index" >
            <span class="field-label">File: </span><a target="_blank" :href="payeeDocument.fileUrl">{{payeeDocument.fileName}}</a><br>
            <span class="field-label">Description: </span>{{payeeDocument.description}}<br>
            <span class="field-label">Participating Provider: </span>{{payeeDocument.organizationPayeeUser.payee.businessName}}<br>
            <span v-if="payeeDocument.organizationPayeeUser.user" class="field-label">Uploaded By: </span>{{ displayName(payeeDocument) }}<br>
          </div>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="closeModal()">Close
      </button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'

  export default {
    name: 'ViewFileModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      payeeDocuments: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        viewFile: '',
        errors: []
      }
    },

    methods: {
      displayName (payeeDocument) {
        if (payeeDocument.organizationPayeeUser && payeeDocument.organizationPayeeUser.user) {
          let name = ''
          const payeeUser = payeeDocument.organizationPayeeUser.user
          if (payeeUser.firstName) {
            name += payeeUser.firstName
          }
          if (payeeUser.lastName) {
            name += ' ' + payeeUser.lastName
          }
          return name
        }
      },
      closeModal () {
        this.clearAllErrors()
        this.$emit('update:visible', false)
      }
    },
    created () {
    }
  }
</script>

<style scoped>
.file-container {
  text-align: center;
}

.file-list {
  display: inline-block;
  text-align: left;
}
</style>
